import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import { Provider } from '../../../generated/graphql';
import { selectMatching } from '../../../redux/matching';

const getCancellationAlertText = (provider: Partial<Provider>): string => {
  const { firstName, lastName, primaryCredential } = provider;
  return `Your Zocdoc appointment with ${firstName} ${lastName}, ${primaryCredential}, has been cancelled.`;
};

const ZocdocCancellationAlert = () => {
  const { zocdocProvider } = useSelector(selectMatching);

  if (!zocdocProvider) return null;

  return (
    <Alert severity="info">{getCancellationAlertText(zocdocProvider)}</Alert>
  );
};

export default ZocdocCancellationAlert;
